











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemoveReflectTemplatePromptMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReflectPrompt",
      "kind": "LinkedField",
      "name": "prompt",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "teamId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RemoveReflectTemplatePromptPayload",
  "abstractKey": null
};

(node ).hash = "ac30008fc5a2cc1bf81d3fdfa6fc458b";

export default node;
